<template>
  <div>
      <div class="block">
          <img alt="" class="grid-avatar-img h-16" :src="getImgUrl(img)"/>
      </div>
      <div class="block mt-2">
          <div class="device-text-container">
              <span class="main-info colored-info" v-if="name">
                  {{ name }}
              </span>
              <span class="subtext-info">
                  {{description}}
              </span>
          </div>
          <div class="device-text-container" v-if="name2 !== undefined && name2 !== ''">
              <span class="main-info colored-info" v-if="name">
                  {{ name2 }}
              </span>
              <span class="subtext-info">
                  {{description2}}
              </span>
          </div>
      </div>
  </div>
</template>
<script>
export default {
  props: {
    img: String,
    name: String,
    description: String,
    name2: String,
    description2: String
  },
  methods: {
    getImgUrl (name) {
      const images = require.context('@/assets/images/icons/', false, /\.svg$/)
      return images(`./${name}.svg`)
    }
  }
}
</script>
